<div class="row page-header">
    <div class="col-12 foreman-schedule-header">
        <h1>Foreman Schedule <small>Plan and project crew assignments across jobs</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Schedule Summary</a>
            <ng-template ngbNavContent>
                <app-foreman-schedule-summary-tab
                    [isActive]="activeTab === 1"
                    [activeJobs]="activeJobs()"
                    [reassignments]="crewReassignments()"
                    [savedSegments]="savedSegments()"
                    [savedWeekendEntries]="savedWeekendEntries()"
                    [foremanRevision]="foremanRevision()"
                ></app-foreman-schedule-summary-tab>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Dashboard</a>
            <ng-template ngbNavContent>
                <app-foreman-schedule-dashboard-tab
                    [isActive]="activeTab === 2"
                    [activeJobs]="activeJobs()"
                    [reassignments]="crewReassignments()"
                    [savedSegments]="savedSegments()"
                    [savedWeekendEntries]="savedWeekendEntries()"
                    [foremanRevision]="foremanRevision()"
                ></app-foreman-schedule-dashboard-tab>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Crew Schedule</a>
            <ng-template ngbNavContent>
                <app-foreman-schedule-crew-schedule-tab
                    [isActive]="activeTab === 3"
                    [activeJobs]="activeJobs()"
                    [canEdit]="canEdit()"
                    [reassignments]="crewReassignments()"
                    [savedSegments]="savedSegments()"
                    [savedWeekendEntries]="savedWeekendEntries()"
                    [foremanRevision]="foremanRevision()"
                ></app-foreman-schedule-crew-schedule-tab>
            </ng-template>
        </li>
        @if (canEdit()) {
            <li [ngbNavItem]="4" [destroyOnHide]="false">
                <a ngbNavLink>Crews</a>
                <ng-template ngbNavContent>
                    <app-foreman-schedule-crews-tab
                        [isActive]="activeTab === 4"
                        [canEdit]="canEdit()"
                        [reassignments]="crewReassignments()"
                        [foremanRevision]="foremanRevision()"
                        (reassignmentsChange)="setCrewReassignments($event)"
                    ></app-foreman-schedule-crews-tab>
                </ng-template>
            </li>
        }
        @if (canManageRoster()) {
            <li [ngbNavItem]="5" [destroyOnHide]="false">
                <a ngbNavLink>Foreman</a>
                <ng-template ngbNavContent>
                    <app-foreman-schedule-foreman-tab
                        [isActive]="activeTab === 5"
                        [canEdit]="canEdit()"
                        (foremanChanged)="onForemanChanged()"
                    ></app-foreman-schedule-foreman-tab>
                </ng-template>
            </li>
            <li [ngbNavItem]="6" [destroyOnHide]="false">
                <a ngbNavLink>Notifications</a>
                <ng-template ngbNavContent>
                    <app-foreman-schedule-notifications-tab [isActive]="activeTab === 6"></app-foreman-schedule-notifications-tab>
                </ng-template>
            </li>
        }
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
